import { LineReason, description} from "../zugferd_2_3_2/linereason"
export { LineReason, description }